module.exports = __webpack_public_path__ + "img/tiktok.d70737f4.svg";